import { useEffect, useState } from 'react';
import { useDataContext } from 'src/contexts';
import { StepsEnum } from 'src/types';
import { useSteps } from 'src/hooks';

const CAPTURED_MESSAGES = [
  'We captured your moment.',
  'Your story is almost ready.',
  'We are adding some magic to your video.',
] as const;

const CAPTURED_MESSAGE_ROTATION_INTERVAL = 5000;
const step = StepsEnum.CAPTURED;

export const useCapturedStep = () => {
  const hasMedia = useDataContext((ctx) => ctx.hasMedia);
  const { activeStep, nextStep } = useSteps();
  const [messageIndex, setMessageIndex] = useState(0);

  const isActive = activeStep === step;

  useEffect(() => {
    if (!isActive) {
      setMessageIndex(0);
      return;
    }

    if (hasMedia) {
      nextStep();
      return;
    }

    const intervalId = window.setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % CAPTURED_MESSAGES.length);
    }, CAPTURED_MESSAGE_ROTATION_INTERVAL);

    return () => {
      clearInterval(intervalId);
    };
  }, [activeStep, hasMedia, nextStep]);

  const capturedMessage = CAPTURED_MESSAGES[messageIndex];
  const capturedMessageKey = capturedMessage.replace(/\s+/g, '-').toLowerCase();

  return {
    capturedMessage,
    capturedMessageKey,
  };
};
